import React from 'react';

const WarningMessages = () => {
  return (
    <div className="warning-messages-page">
      <h2>Mensagens de Aviso</h2>
      <p>Configure as mensagens de aviso do sistema.</p>
    </div>
  );
};

export default WarningMessages;
